import { render } from "./ReferenceDetailsLabels.vue?vue&type=template&id=1a7c2221&scoped=true"
import script from "./ReferenceDetailsLabels.vue?vue&type=script&lang=js"
export * from "./ReferenceDetailsLabels.vue?vue&type=script&lang=js"

import "./ReferenceDetailsLabels.vue?vue&type=style&index=0&id=1a7c2221&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7c2221"]])

export default __exports__